var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBQ(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#111",
    stroke: "#aaa",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 9,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 8,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 9,
    r: 2.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 12,
    r: 2.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9,26 C 17.5,24.5 30,24.5 36,26 L 38.5,13.5 L 31,25 L 30.7,10.9 L 22.5,24.5 L 14.3,10.9 L 14,25 L 6.5,13.5 L 9,26 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9,26 C 9,28 10.5,28 11.5,30 C 12.5,31.5 12.5,31 12,33.5 C 10.5,34.5 10.5,36 10.5,36 C 9,37.5 11,38.5 14,39.5 C 17.5,40 21.5,40.5 22.5,40.5 C 23.5,40.5 27.5,40 31,39.5 C 34,38.5 36,37.5 34.5,36 C 34.5,36 34.5,34.5 33,33.5 C 32.5,31 32.5,31.5 33.5,30 C 34.5,28 36,28 36,26 C 27.5,24.5 17.5,24.5 9,26 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.5,30 C 15,29 30,29 33.5,30",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,33.5 C 15,32.5 30,32.5 33,33.5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.5,36 C 15,34.5 30,34.5 34.5,36",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBQ);
export default __webpack_public_path__ + "static/media/bQ.57ff3d75bdcaaf7f985006bc7de797aa.svg";
export { ForwardRef as ReactComponent };